import React, { useState } from 'react'

import { Wizard, WizardStep } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { stringToDate } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import { destinationStep } from 'modules/shift_management/components/ShiftManagement/CopyPeriodWizard/DestinationStep'
import { originStep } from 'modules/shift_management/components/ShiftManagement/CopyPeriodWizard/OriginStep'
import {
  useCopyPeriodCoverage,
  useCopyPeriodSchedule,
} from 'modules/shift_management/components/ShiftManagement/CopyPeriodWizard/useCopyPeriod'
import {
  CopyTypeEnum,
  diffBetweenDateTimes,
} from 'modules/shift_management/components/ShiftManagement/CopyPeriodWizard/utils'
import { WizardData } from 'modules/shift_management/components/ShiftManagement/CopyPeriodWizard/utils'
import { useSchedule } from 'modules/shift_management/hooks/useSchedule'

interface Props {
  onClose: () => void
}

const CopyShiftWizard = ({ onClose }: Props) => {
  const steps: WizardStep<WizardData>[] = [originStep(), destinationStep()]
  const [{ view }] = useSchedule()

  const initialData: WizardData = {
    startDateSchedule: view.startAt,
    endDateSchedule: view.endAt,
    daysSchedule: diffBetweenDateTimes(view.startAt, view.endAt),
    startDateCoverage: view.startAt,
    endDateCoverage: view.endAt,
    daysCoverage: diffBetweenDateTimes(view.startAt, view.endAt),
    destinationStartDate: '',
    copyType: CopyTypeEnum.schedule,
  }

  const title = i18n.t('shift_management.copy_schedule_period.title')
  const description = i18n.t('shift_management.copy_schedule_period.main_description')

  const [wizardData, setWizardData] = useState<WizardData>(initialData)

  const handleOnDataChanged = (newData: WizardData) => {
    setWizardData({ ...wizardData, ...newData })
  }

  const { handleScheduleSubmit, submitting } = useCopyPeriodSchedule({
    data: wizardData,
    targetView: view.specificPeriod(stringToDate(wizardData.destinationStartDate, 'backend')),
    onClose: onClose,
  })

  const { handleCoverageSubmit } = useCopyPeriodCoverage({
    data: wizardData,
    targetView: view.specificPeriod(stringToDate(wizardData.destinationStartDate, 'backend')),
    onClose: onClose,
  })

  return (
    <Wizard.Modal
      title={title}
      description={description}
      steps={steps}
      initialData={initialData}
      onSubmit={
        wizardData.copyType === CopyTypeEnum.schedule ? handleScheduleSubmit : handleCoverageSubmit
      }
      onClose={onClose}
      onDataChanged={handleOnDataChanged}
      locked={submitting}
    />
  )
}

export default observer(CopyShiftWizard)
